export const WIRE_DETAILS = [
  {
    label: 'Bank Name',
    value: 'BMO Harris Bank',
  },

  {
    label: 'Bank Address',
    value: '111 W. Monroe St, Chicago, IL 60603',
  },

  {
    label: 'Routing # (ABA)',
    value: '071000288',
  },

  {
    label: 'SWIFT Code',
    value: 'HATRUS44',
  },

  {
    label: 'Account Holder',
    value: 'Apex Clearing',
  },

  {
    label: 'Account #',
    value: '3713286',
  },
];
